import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { mutationFnPOST } from "api/tanStackQuery/helpers";
import { StationEventModal } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/StationEventModal";
import {
  formSchema,
  FormSchema,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/formSchema";
import { StationInfoRequest } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/requestSchema";
import { StationEventResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/responseSchema";
import { stationEventResponseToForm } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/transformers";
import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useFormVerbose } from "shared/form/useFormVerbose";
import { useCountryCodeForDropsRole } from "shared/hooks/useCountryCodeForDropsRole";
import { useStretchBuilder } from "stores/useStretchBuilder";

export const StationEvent: FC = () => {
  const countryCodeForDropsRole = useCountryCodeForDropsRole();

  const [stretchBuilderModalState, getStationEvent] = useStretchBuilder(
    (state) => [state.stretchBuilderModalState, state.getStationEvent],
  );

  const event = getStationEvent();
  const isEditMode = !!event;

  const defaultValues = {
    stationForm: isEditMode
      ? stationEventResponseToForm(event)
      : {
          stationInformationType: undefined,
          stops: [],
        },
  };

  const formMethods = useFormVerbose<FormSchema>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: "onSubmit",
  });

  const { mutateAsync: postStationInfo, status: postStationInfoStatus } =
    useMutation({
      mutationFn: (data: StationInfoRequest) =>
        mutationFnPOST<StationEventResponse, StationInfoRequest>(
          `${getBackendUrl()}/station-information${isEditMode ? `/${event.uuid}/change` : `?countryCode=${countryCodeForDropsRole}`}`,
          data,
        ),
    });

  if (stretchBuilderModalState.type !== "station") return null;

  return (
    <FormProvider {...formMethods}>
      {!stretchBuilderModalState.stretchBuilderMode ? (
        <StationEventModal
          onFormSubmit={postStationInfo}
          formSubmitStatus={postStationInfoStatus}
        />
      ) : (
        <div />
      )}
    </FormProvider>
  );
};
